import React from "react";
import { CtaButton } from "../Buttons";
import { PlayerMiniCard } from "../PlayerMiniCard";
import {
  formatStatValue,
  getPriceTrendClass,
} from "../../Common/utils/statistics";

const StatisticCard = ({
  StatsCardTitle,
  StatsCardCtaText,
  data = [],
  imageSrc,
  handleClick = () => {
    return null;
  },
  type = "text",
}) => {

  return (
    <>
      <div className="si-stats__card">
        <div className="si-stats__card-top">
          <h2 className="si-stats__card-title">{StatsCardTitle}</h2>
        </div>
        <div className="si-stats__card-mid">
          <div className="si-stats__card-list">
            <ul>
              {data.map((item, index) => (
                <li key={index}>
                  <div className="si-stats__srNo">{item?.rnk}</div>
                  <div className="si-stats__plyrDtls">
                    <PlayerMiniCard
                      teamID={item?.teamid || item?.playerid}
                      imageSrc={imageSrc}
                      imageName={`${item?.playerid}.png`}
                      PlayerMiniCardName={item.FUllName}
                      PlayerMiniCardTeam={false}
                      statisticsPlayer={item}
                      isNameSplit={item?.PositionName === "CONSTRUCTOR" ? false : true}
                    />
                  </div>
                  <div
                    className={`si-stats__pts ${getPriceTrendClass(
                      type,
                      item,
                      "statvalue"
                    )}`}
                  >
                    {formatStatValue(type, item, "statvalue")}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="si-stats__card-bot">
          <CtaButton
            fullWidth={true}
            variant={"secondary"}
            onClick={handleClick}
          >
            {StatsCardCtaText}
          </CtaButton>
        </div>
      </div>
    </>
  );
};

export { StatisticCard };
